import React from "react"
import styled from "styled-components"

// Styling
import colors from "../../../styles/colors"
import textStyles from "../../../styles/textStyles"
import mq from "../../../styles/breakpoints"

// Components
import Label from "../atoms/Label"
import Error from "../atoms/Error"

interface IProps {
  label: string
  name: string
  reference: any
  error?: string
  rows?: number
  type?: string
}

const TextArea: React.FC<IProps> = ({
  label,
  name,
  reference,
  error,
  rows = 4,
}) => (
  <Container>
    <Label label={label} />
    <Input name={name} rows={rows} ref={reference} />
    <Error error={error} />
  </Container>
)

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 16px;
`

const Input = styled.textarea`
  ${textStyles.body};
  width: 100%;
  margin-bottom: 0;
  padding: 12px 18px;
  border: 2px solid ${colors.whitePurple};
  color: ${colors.blueGrey};
  border-radius: 8px;
  outline: none;
  -webkit-appearance: none;
  resize: none;

  ${mq.from.S`
    margin-bottom: 0;
  `}

  :focus {
    border: 2px solid ${colors.blueGrey};
  }
`

export default TextArea
